module.exports = __webpack_public_path__ + "img/Artboard8.ec9c8fed.webp";